import React from 'react';
import PropTypes from 'prop-types';

const BCPrefillModal = ({ productName, bcRequestNumber, skiRelease, onConfirm, onDismiss }) => (
  <div className="bc-draft-modal-overlay">
    <div className="bc-draft-modal">
      <h3 className="bc-draft-modal__title">Breaking Change Request Found</h3>
      <p className="bc-draft-modal__message">
        A verified Breaking Change request (<strong>{bcRequestNumber}</strong>) already exists for{' '}
        <strong>{productName}</strong>
        {skiRelease ? ` (${skiRelease})` : ''}.
      </p>
      <p className="bc-draft-modal__message">
        Would you like to pre-fill this CiC request with the answers from that Breaking Change?
      </p>
      <div className="bc-draft-modal__actions">
        <button className="bc-draft-modal__btn bc-draft-modal__btn--primary" onClick={onConfirm}>
          Yes, pre-fill fields
        </button>
        <button className="bc-draft-modal__btn bc-draft-modal__btn--secondary" onClick={onDismiss}>
          No, start blank
        </button>
      </div>
    </div>
  </div>
);

BCPrefillModal.propTypes = {
  productName: PropTypes.string.isRequired,
  bcRequestNumber: PropTypes.string.isRequired,
  skiRelease: PropTypes.string,
  onConfirm: PropTypes.func.isRequired,
  onDismiss: PropTypes.func.isRequired,
};

BCPrefillModal.defaultProps = {
  skiRelease: null,
};

export default BCPrefillModal;
